import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { WidjetPage } from './pages/WidjetPage/WidjetPage';

const root = createRoot(document.getElementById('booking-widjet'));
root.render(
    <WidjetPage />
);
